module.exports = __webpack_public_path__ + "static/media/tmdb_logo.866fd72f.svg";